import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-operation-note-document-form',
  templateUrl: './operation-note-document-form.component.html',
  styleUrls: ['./operation-note-document-form.component.scss']
})
export class OperationNoteDocumentFormComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
